import * as React from 'react';
import clsx from 'clsx';
var styles = {
  "root": "Main-root_2G7gZ",
  "content": "Main-content_1vZd5"
};
function Main(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("main", {
    className: clsx(styles.root, className)
  }, /*#__PURE__*/React.createElement("section", {
    className: styles.content
  }, children));
}
export default Main;